import { watchVehicle } from './action';
import vehicleReducer from './reducer';

export function getVehicleModule() {
  return {
    // Unique id of the module
    id: 'vehicleNew',
    // Maps the Store key to the reducer
    reducerMap: {
      vehicleNew: vehicleReducer,
    },
    // This module uses redux-saga middleware
    // This property will be be used by the SagaExtension
    // to run sagas for the moduleD
    sagas: [watchVehicle],
  };
}
